import type { CentrifugeMessage } from '../messageTypes';

export interface SoundOnMessage {
  channel: string;
  data: {
    type: 'SoundOn';
    message: string;
    created_at: number;
  };
  offset: number;
}

export const isSoundOnMessage = (item: CentrifugeMessage): item is SoundOnMessage => {
  return 'data' in item && item.data.type === 'SoundOn';
};

export interface SoundOffMessage {
  channel: string;
  data: {
    type: 'SoundOff';
    message: string;
    created_at: number;
  };
  offset: number;
}

export const isSoundOffMessage = (item: CentrifugeMessage): item is SoundOffMessage => {
  return 'data' in item && item.data.type === 'SoundOff';
};
